import { render } from "./searchorderuserhb.vue?vue&type=template&id=c116c598"
import script from "./searchorderuserhb.vue?vue&type=script&lang=js"
export * from "./searchorderuserhb.vue?vue&type=script&lang=js"

import exportComponent from "D:\\work\\web\\sal_appgd\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__